import { Alert, Box, Container, Paper, Typography } from '@mui/material';
import React, { useEffect } from 'react';

const Send: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Container maxWidth='md'>
      <Box>
        <Paper elevation={0} sx={{ p: 6 }}>
          <Typography variant='h4' gutterBottom align='center'>
            <b>Vielen Dank!</b>
          </Typography>

          <Typography variant='body1' paragraph align='center'>
            Ihre Eingaben sind erfolgreich an uns übermittelt worden. Wir werden
            Ihr Anliegen nun überprüfen und uns in Kürze mit Ihnen in Verbindung
            setzen.
          </Typography>

          <Typography variant='body1' paragraph align='center'>
            <b>Sind Sie bereits in unserem Mandantenportal angemeldet?</b>
          </Typography>

          <Typography variant='body1' paragraph align='center'>
            Im Mandantenportal können Sie Ihre Vorgänge von Anfang bis Ende
            mitverfolgen und bleiben stets über den aktuellen Bearbeitungsstatus
            informiert. Darüber hinaus können Sie dort Ihre Termine
            organisieren, Ihre Dokumente und Rechnungen abrufen sowie Ihre
            persönlichen Daten verwalten.
          </Typography>

          <Typography variant='body1' paragraph align='center'>
            Um diese Vorteile nutzen zu können, erhalten Sie von uns per E-Mail
            eine Einladung zu Ihrem neuen Vorgang. Bitte nehmen Sie diese an.
            Sofern Sie noch keinen Account im Mandantenportal haben, senden wir
            Ihnen darüber hinaus eine E-Mail, über die Sie mit wenigen Klicks
            die Einrichtung Ihres Benutzerkontos abschließen können.
          </Typography>

          <Typography variant='body1' paragraph align='center'>
            Laden Sie auch andere Beteiligte zum DiNo-Mandantenportal ein! Dies
            ist im Mandantenportal mit wenigen Klicks direkt aus Ihrem Vorgang
            heraus möglich. Eine detaillierte Anleitung finden Sie zudem im
            Login-Bereich des Mandantenportals.
          </Typography>

          <Box mt={2}>
            <Alert
              severity='info'
              variant='outlined'
              sx={{ justifyContent: 'center', textAlign: 'center' }}
            >
              Sie können die Seite nun schließen.
            </Alert>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Send;
